import { BehaviorSubject, Observable, rx } from '@app/shared/rx';
import { isEmpty } from 'lodash';

export const GLOBAL_DND_COMP_SHOW_LOADER$ = new BehaviorSubject<{
  key: string;
  show?: boolean;
}>({
  key: '',
});

export const GLOBAL_DND_COMPLICATE_COMP_SHOW_LOADER_OBS: Observable<
  Record<string, boolean>
> = GLOBAL_DND_COMP_SHOW_LOADER$.pipe(
  rx.scan(
    (acc, cur) =>
      isEmpty(cur.key) ? { ...acc } : { ...acc, [cur.key]: cur.show },
    {},
  ),
);
